export const CONTEXT_UPDATE = 'dismissableLayer.update';
export const POINTER_DOWN_OUTSIDE = 'dismissableLayer.pointerDownOutside';
export const FOCUS_OUTSIDE = 'dismissableLayer.focusOutside';